import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface GetCrmSnapshotDataPayload {
  apiKey: string;
}

export interface GetCrmSnapshotDataResponse {
  success: boolean;
  generatedAt: number;
  contactCount: number;
  snapshot: {
    meta: Record<string, unknown>;
    contacts: Record<string, unknown>[];
  };
}

async function getCrmSnapshotData(
  payload: GetCrmSnapshotDataPayload,
  auth: Authentication
): Promise<GetCrmSnapshotDataResponse> {
  try {
    return await HttpClient.get(
      `/integrations/contacts/snapshot/data?apiKey=${encodeURIComponent(payload.apiKey)}`,
      auth.token,
      { 'x-api-key': payload.apiKey },
    );
  } catch (e: any) {
    const errorMessage = e.message || 'Unknown error';
    throw new GetCrmSnapshotDataFailure(errorMessage, 'snapshot-data-error');
  }
}

class GetCrmSnapshotDataFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getCrmSnapshotData;
